var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.78999 17.79V8.79004C2.78999 7.19874 3.42213 5.67262 4.54735 4.5474C5.67257 3.42218 7.19869 2.79004 8.78999 2.79004C10.3813 2.79004 11.9074 3.42218 13.0326 4.5474C14.1579 5.67262 14.79 7.19874 14.79 8.79004V17.79M2.78999 17.79H14.79M2.78999 17.79H0.789993M14.79 17.79H16.79M7.78999 20.79H9.78999",
    stroke: "#364153",
    strokeWidth: 1.58,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.78999 2.79004C9.34228 2.79004 9.78999 2.34232 9.78999 1.79004C9.78999 1.23775 9.34228 0.790039 8.78999 0.790039C8.23771 0.790039 7.78999 1.23775 7.78999 1.79004C7.78999 2.34232 8.23771 2.79004 8.78999 2.79004Z",
    stroke: "#364153",
    strokeWidth: 1.58
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.b1c6f366ba50ca23c8d7ee0f0f4fa660.svg";
export { ForwardRef as ReactComponent };